import React from 'react';
import 'whatwg-fetch';
import { showEntity } from 'src/utils/entityApi';
import withAuth from 'src/hoc/withAuth';

const apiTicketReasonClose = '/api/ticket/getReasonsOfClosing/';
const oriState = {
  dataClosedReason: undefined,
  closedReasonId: -1,
  comment: undefined,
};

class ModalTicketClose extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
    this.close = this.close.bind(this);
    this.reset = this.reset.bind(this);
    this.findReasons = this.findReasons.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    this.findReasons();
  }

  findReasons() {
    let queryURL = apiTicketReasonClose;
    let graphQL = '{ ticketClosedReasons{ id, label} }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['ticketClosedReasons']) {
            this.setState({
              dataClosedReason: data['data']['ticketClosedReasons'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch reason of closing');
        }.bind(this)
      );
  }

  checkFormValid() {
    return this.props.myTicket.isClosed || (this.state.closedReasonId && this.state.closedReasonId !== -1);
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { dataClosedReason } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>{this.props.myTicket.isClosed ? 'Réouverture ticket' : 'Fermer ticket'}</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <div className='modal-body'>
              {this.props.myTicket.isClosed ? (
                <p>{'Vous allez réouvrir le ticket "' + this.props.myTicket.name + '"'}</p>
              ) : (
                <p>{'Vous allez clôturer le ticket "' + this.props.myTicket.name + '"'}</p>
              )}
            </div>
            <form>
              <div className='modal-body'>
                {!this.props.myTicket.isClosed && (
                  <div>
                    <div className='form-group'>
                      <label>Raison de l'incident</label>
                      <select
                        name='closedReasonId'
                        value={this.state.closedReasonId}
                        onChange={this.handleInputChange}
                        className='form-control'
                      >
                        <option value={-1}>Sélectionner la responsabilité de l'incident</option>
                        {dataClosedReason ? (
                          dataClosedReason.map((data, key) => (
                            <option value={data.id} key={key}>
                              {data.label}
                            </option>
                          ))
                        ) : (
                          <span>Chargement...</span>
                        )}
                      </select>
                    </div>
                    <div className='form-group'>
                      <label>Commentaire</label>
                      <textarea
                        name='comment'
                        value={this.state.comment}
                        onChange={this.handleInputChange}
                        type='text'
                        className='form-control'
                        placeholder='Commentaire sur la résolution du ticket'
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Valider</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormValid()) {
        let comment = this.state.comment ? '"' + this.state.comment + '"' : null;
        let graphQL =
          'mutation{ ticket(id:' +
          this.props.myTicket.id +
          ', closed:' +
          !this.props.myTicket.isClosed +
          ', closingComment:' +
          comment +
          ', ticketClosedReasonId:' +
          this.state.closedReasonId +
          '){ id, closed } }';
        this.props.onPostResult('ticket-closing', showEntity(this.props.authFetch, 'ticket', graphQL));
        this.close();
      } else {
        this.props.openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalTicketClose);
